import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "react-md";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { MSpinner, MTable } from "components/Shared";
import { getCaseNotifications, resendCaseNotification, stopResendCaseNotification } from "requests/homeowner/ho";
import { dateTimeToStringWithDOW } from "components/Shared/Formatters";
import responseHandler from "responseHandler";
import { connect } from "react-redux";

function Notifications(props) {

  const [expanded, setExpanded] = useState(false);
  const [notifications, setNotifications] = useState();

  const mounted = useRef(true);

  const toggleExpanded = () => setExpanded(!expanded);
  const getNotifications = () => {
    getCaseNotifications(props.controlNumber, updateNotifications, mounted);
  };

  const updateNotifications = notifications => {
    notifications.forEach((n, i) => {
      let firstIndex = notifications.findIndex(el => el.code === n.code);
      n.isFirst = firstIndex == i;
    });
    setNotifications(notifications);
  };

  const resendNotification = code => {
    resendCaseNotification(props.controlNumber, code, () => {
      getNotifications();
      props.makeToast(`${code} has been resent`);
    }, mounted);
  };

  const stopResendNotification = code => {
    stopResendCaseNotification(props.controlNumber, code, () => {
      getNotifications();
      props.makeToast(`${code} has been stopped from resending`);
    }, mounted);
  };

  const getSendAgain = note => {
    if (note.isFirst) {
      if (note.isSending) {
        return (<Button
          onClick={() => stopResendNotification(note.code)}
          primary
          raised
          type="submit"
          children="Stop Re-Send"
          className="case-history-input-field-button"
        />);
      } else {
        return (<Button
          onClick={() => resendNotification(note.code)}
          primary
          raised
          type="submit"
          children="Re-Send"
          className="case-history-input-field-button"
        />);
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    getNotifications();
    return () => {
      mounted.current = false;
    };
  }, []);

  const getNoteDiv = note => <div className="text-pre-wrap-and-word-break">{note.notes}</div>;

  let notificationsControl = <MSpinner />;
  if (notifications) {
    if (notifications.length) notificationsControl = (<MTable
      columnDefinitions={[
        { name: "Date", dataSource: note => dateTimeToStringWithDOW(note.sentDate), style: { width: "200px" } },
        { name: "Notes", dataSource: getNoteDiv },
        { name: "Code", dataSource: "code", style: { width: "230px" } },
        { name: "Send Again", dataSource: getSendAgain, style: { width: "150px" } },
      ]}
      data={notifications}
    />);
    else notificationsControl = "There are no notifications for this case";
  }

  return (<Card className="md-cell md-cell--12 case-header"
    expanded={expanded}
    onExpanderClick={toggleExpanded}>
    <CardTitle
      title="Notifications"
      onClick={toggleExpanded}
      expander />
    <CardText expandable>
      {notificationsControl}
    </CardText>
  </Card>);
}

Notifications.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  makeToast(text) {
    responseHandler.customToast(text, "success", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(Notifications);
